module.exports = global["React"] = require("-!./index.js");